import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PayementsForm from './PayementsForm';
import { getPaymentRedirectionLink } from 'store/features/investments/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  amount: state.investments.amount,
  transfer: state.investments.transfer,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getPaymentRedirectionLink }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayementsForm);
